<template>
  <b-server-table
    :key="renderKey"
    :filter-props="{
      filterMap: [
        { key: 'search' },
        {
          key: 'typeId',
          directory: 'correspondenceTypes',
          component: 'select',
        },
        {
          key: 'statusId',
          directory: 'correspondenceStatuses',
          component: 'select',
        },
        {
          key: 'documentTypeId',
          directory: 'correspondenceDocumentTypes',
          component: 'select',
        },
        {
          key: 'documentDeliveryTypeId',
          directory: 'correspondenceDeliveryTypes',
          component: 'select',
        },
        {
          key: 'departmentId',
          directory: 'departmentList',
          component: 'select',
        },
        {
          key: 'responsibleId',
          directory: 'userList',
          component: 'autocomplete',
        },
      ],
    }"
    :headers="correspondenceListHeaders"
    :request-func="getCorrespondence"
    @click:row="
      $router.push({
        name: 'correspondence-single',
        params: { id: $event.id },
      })
    ">
    <template #action-button>
      <v-btn
        v-if="can('correspondences.create')"
        rounded="lg"
        @click="createCorrespondence">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Створити кореспонденцію
      </v-btn>
    </template>
    <template #item.registrationDate="{ item }">
      {{ new CustomDate(item.registrationDate).toString({ time: true }) }}
    </template>
    <template #[`item.responsible`]="{ item }">
      {{ getPersonName(item.responsible, { initials: true }) }}
    </template>
    <template #[`item.documentType`]="{ item }">
      <span v-if="item.documentType">{{ item.documentType?.name }}</span>
      <v-icon v-else>{{ 'mdi-minus' }}</v-icon>
    </template>
    <template #[`item.contractor`]="{ item }">
      <v-tooltip
        v-if="item.contractor"
        :text="item.contractor?.shortName"
        bottom>
        <template #activator="{ props }">
          <span
            class="link"
            style="
              display: block;
              width: 230px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            v-bind="props"
            @click.stop="
              $router.push({
                name: 'single-contractor',
                params: { id: item?.contractor?.id },
              })
            "
            >{{ item.contractor?.shortName }}</span
          >
        </template>
      </v-tooltip>
      <v-icon v-else>{{ 'mdi-minus' }}</v-icon>
    </template>
    <template #[`item.subject`]="{ item }">
      <v-tooltip v-if="item.subject" :text="item.subject" bottom>
        <template #activator="{ props }">
          <span
            style="
              display: block;
              width: 350px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            v-bind="props"
            >{{ item.subject }}</span
          >
        </template>
      </v-tooltip>
      <v-icon v-else>{{ 'mdi-minus' }}</v-icon>
    </template>
    <template #[`item.documents`]="{ item }">
      <v-icon v-if="item.documents">{{ 'mdi-check' }}</v-icon>
      <v-icon v-else>{{ 'mdi-minus' }}</v-icon>
    </template>
    <template #[`item.actions`]="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Відкрити',
            icon: 'mdi-eye',
            action: () =>
              $router.push({
                name: 'correspondence-single',
                params: { id: item.id },
              }),
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Видалити',
            icon: 'mdi-delete-forever',
            action: () => deleteCorrespondence(item.id),
            listItemProps: {
              class: 'text-error',
            },
            iconProps: {
              color: 'error',
            },
          },
        ]"></b-action-menu>
    </template>
  </b-server-table>
</template>

<script>
import { BActionMenu, BServerTable } from 'best-modules/components'
import axios from '@/plugins/axios'
import { urlCorrespondenceDelete, urlCorrespondenceList } from '@/utils/urls.js'
import { computed, ref } from 'vue'
import { openDialog } from '@/dialog/index.ts'
import { useRouter } from 'vue-router'
import { navigateToItem } from '@/utils/helpers.js'
import { useStore } from 'vuex'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { correspondenceListHeaders } from '@/utils/tableHeaders'
import { useCan } from '@/composables/useCan'

export default {
  name: 'CorrespondenceList',
  components: {
    BServerTable,
    BActionMenu,
  },
  data() {
    return { correspondenceListHeaders }
  },
  methods: { navigateToItem, getPersonName, CustomDate },
  setup() {
    const router = useRouter()
    const store = useStore()
    const { can } = useCan()
    const user = computed(() => {
      return store.state.user.UserData
    })
    const renderKey = ref(1)
    const getCorrespondence = query => {
      return axios.get(urlCorrespondenceList(query)).then(res => res.data)
    }

    const createCorrespondence = () => {
      openDialog({
        name: 'Correspondence',
        params: {
          cb: correspondence => {
            router.push({
              name: 'correspondence-single',
              params: { id: correspondence.id },
            })
          },
          submitLabel: 'Створити',
        },
      })
    }

    const deleteCorrespondence = correspondenceId => {
      return can('correspondences.delete', () => {
        return axios
          .delete(urlCorrespondenceDelete(correspondenceId))
          .then(() => (renderKey.value += 1))
      })
    }

    return {
      renderKey,
      getCorrespondence,
      createCorrespondence,
      deleteCorrespondence,
      user,
      can,
    }
  },
}
</script>
